exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-sku[data-v-3f529555] {\n    min-width: 150px;\n}\n.col-quantity[data-v-3f529555] {\n    min-width: 100px;\n}\n.col-description[data-v-3f529555] {\n    width: 100%;\n}\n", ""]);

// exports
